import { getCurrentUserId } from '../auth';
import { logsink, clientName } from '../config';

function post(data) {
  const xhr = new XMLHttpRequest();
  xhr.open('POST', logsink);
  xhr.setRequestHeader('Content-type', 'application/json');
  xhr.send(JSON.stringify(data));

  return (f) => {
    let done = false;
    const trigger = () => {
      if (done) return;
      done = true;
      f();
    };

    xhr.onload = trigger;
    xhr.onabort = trigger;
    xhr.onerror = trigger;
    xhr.ontimeout = trigger;
  };
}

function processException({ name, message, stack }) {
  return {
    message,
    type: name,
    stackTrace: stack,
  };
}

function log({ scope, severity, message, exception }) {
  let schedule = null;
  let ready = true;

  if (!message || typeof message !== 'string') ready = false;
  if (scope !== undefined && typeof scope !== 'string') ready = false;
  if (exception !== undefined && !(exception instanceof Error)) ready = false;

  // just ignore if params are not valid
  if (ready) {
    const payload = {
      scope,
      severity,
      message,
      user: getCurrentUserId(),
      exception: exception && processException(exception),
      client: clientName,
    };

    if (logsink) schedule = post(payload);
    // eslint-disable-next-line no-console
    else console.log(payload);
  }

  return {
    then: f => (schedule ? schedule(f) : f()),
  };
}

export function createLogger(scope) {
  return {
    trace: ({ ...args }) => log({ ...args, scope, severity: 'Trace' }),
    debug: ({ ...args }) => log({ ...args, scope, severity: 'Debug' }),
    information: ({ ...args }) => log({ ...args, scope, severity: 'Information' }),
    warning: ({ ...args }) => log({ ...args, scope, severity: 'Warning' }),
    error: ({ ...args }) => log({ ...args, scope, severity: 'Error' }),
    critical: ({ ...args }) => log({ ...args, scope, severity: 'Critical' }),
  };
}

export default createLogger();



// WEBPACK FOOTER //
// ./src/logger/index.js